// Iframe click detection (e.g. Trustpilot widgets)
// Cross-origin iframes block click events, so we detect clicks via window blur
// while the mouse is hovering over a tracked container.
document.querySelectorAll('[data-ga-iframe-event]').forEach(function (container) {
  let isHovering = false;

  container.addEventListener('mouseenter', function () { isHovering = true; });
  container.addEventListener('mouseleave', function () { isHovering = false; });

  window.addEventListener('blur', function () {
    if (isHovering) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: container.dataset.gaIframeEvent,
      });
    }
  });
});

// Livewire event listener
// Usage: $this->dispatch('ga-event', name: 'your_event_name')
document.addEventListener('livewire:init', () => {
  Livewire.on('ga-event', (data) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: data.name });
  });
});

document.addEventListener('click', function (e) {
  const el = e.target.closest('[data-ga-event]');
  if (!el) return;

  const data = {};

  try {
    // setup possible ga event variables
    for (const [key, value] of Object.entries(el.dataset)) {
      if (key.startsWith('gaVar')) {
        data[key.replace('gaVar', '')] = value;
      }
    }
  } catch (error) {
    console.error(error);
  }

  data.event = el.dataset.gaEvent;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
});
